import * as React from 'react';

const EmptyInvoiceCardList = ({ show }): JSX.Element => {
  return show && <div className="no-supplier-invoices">No supplier invoices found.</div>;
};

export default EmptyInvoiceCardList;
